/* Angular   Libraries */
import {Routes} from '@angular/router';
/* Local Guards */
import { AuthGuard } from '../shared/guards/auth.guard';
/* Local Components */
import {LayoutComponent} from './layout.component';

export const LayoutRoutes: Routes = [
	{
		//path: '', component: LayoutComponent, canActivate: [AuthGuard],
    path: '', component: LayoutComponent,
		children: [
			{path: '', redirectTo: '', pathMatch: 'prefix'},
      {
        path: 'engineer',
        canActivate: [AuthGuard],
        loadChildren: () => import('./../modules/engineer/engineer.module').then(m => m.EngineerModule)
      },
      {
        path: 'projectmanager',
        canActivate: [AuthGuard],
        loadChildren: () => import('./../modules/projectmanager/project-manager.module').then(m => m.ProjectManagerModule)
      },
      {
        path: 'termsandconditions',
        loadChildren: () => import('./../modules/tandc/termsandconditions.module').then(m => m.TermsAndConditionsModule)
      },
		]
  },
	{ path: '**', pathMatch: 'full', redirectTo: 'error/404'}
];


